import { render, staticRenderFns } from "./follow-wares.vue?vue&type=template&id=76ae8946&scoped=true"
import script from "./follow-wares.vue?vue&type=script&lang=js"
export * from "./follow-wares.vue?vue&type=script&lang=js"
import style0 from "./follow-wares.vue?vue&type=style&index=0&id=76ae8946&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ae8946",
  null
  
)

export default component.exports